import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-k', 'LetterK', [["path",{"d":"M7 4l0 16"}],["path",{"d":"M7 12h2l8 -8"}],["path",{"d":"M9 12l8 8"}]]);